import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ServiceWorkerModule } from '@angular/service-worker';

import { environment } from '../environments/environment';
import { DceHeaderModule } from './dce-header/dce-header.module';
import { AppRoutingModule } from './app-routing.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ModalModule} from 'ngx-bootstrap/modal';
import {TooltipModule } from 'ngx-bootstrap/tooltip';
import { DataTablesModule } from 'angular-datatables';
import { ToastrModule } from 'ngx-toastr';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS} from '@angular/common/http';
import { MaterialModule } from '@cs/material';
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
import { AdsHeaderModule } from './ads-header/ads-header.module';
import { ModalService } from '@cs/core-data';
import { NgxSpinnerModule } from 'ngx-spinner';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MsalModule, MsalRedirectComponent, MsalGuard, MsalService, MsalBroadcastService, MSAL_INSTANCE, MSAL_GUARD_CONFIG, MSAL_INTERCEPTOR_CONFIG, MsalInterceptor, MsalGuardConfiguration, MsalInterceptorConfiguration } from '@azure/msal-angular';
import { PublicClientApplication, InteractionType, IPublicClientApplication } from '@azure/msal-browser';


export function MSALInstanceFactory(): IPublicClientApplication {
    return new PublicClientApplication(environment.msalConfig);
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
    return {
        interactionType: InteractionType.Redirect,
        authRequest: {
            scopes: ['openid', 'profile','user.read']
        }
    };
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
    const protectedResourceMap = new Map<string, Array<string>>();
    // Add your API URLs and scopes here if needed
    return {
        interactionType: InteractionType.Redirect,
        protectedResourceMap
    };
}
@NgModule({ declarations: [],
    exports: [RouterModule, MatDatepickerModule],
    bootstrap: [MsalRedirectComponent], 
    imports: [MatDatepickerModule,
        BrowserAnimationsModule,
        BrowserModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
        AdsHeaderModule,
        DceHeaderModule,
        ModalModule.forRoot(),
        TooltipModule.forRoot(),
        DataTablesModule,
        MsalModule,
        ToastrModule.forRoot({
            positionClass: 'toast-bottom-center',
            newestOnTop: true
        }),
        LoadingBarHttpClientModule,
        ServiceWorkerModule.register('ngsw-worker.js', {
            enabled: environment.production
        }),
        AppRoutingModule,
        NgxSpinnerModule
    ],
    providers: [
        ModalService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: MsalInterceptor,
            multi: true
        },
        {
            provide: MSAL_INSTANCE,
            useFactory: MSALInstanceFactory
        },
        {
            provide: MSAL_GUARD_CONFIG,
            useFactory: MSALGuardConfigFactory
        },
        {
            provide: MSAL_INTERCEPTOR_CONFIG,
            useFactory: MSALInterceptorConfigFactory
        },
        MsalService,
        MsalGuard,
        MsalBroadcastService
    ]   
        })
export class AppModule {}
